(function () {
  var root = document.getElementById('collection-2026-01-26-01-26');
  if (!root) return;

  var q = root.querySelector('[data-filter="query"]');
  var power = root.querySelector('[data-filter="power"]');
  var thermostat = root.querySelector('[data-filter="thermostat"]');
  var noise = root.querySelector('[data-filter="noise"]');
  var count = root.querySelector('[data-count]');
  var year = root.querySelector('[data-year]');
  var compareBtn = root.querySelector('[data-action="compare"]');

  if (year) year.textContent = String(new Date().getFullYear());

  var compareMode = false;
  var selected = new Set();

  function normalize(val) {
    return (val || '').toLowerCase().trim();
  }

  function applyFilters() {
    if (!q && !power && !thermostat && !noise) return;

    var query = q ? normalize(q.value) : '';
    var p = power ? power.value : 'all';
    var t = thermostat ? thermostat.value : 'all';
    var n = noise ? noise.value : 'all';

    var cards = root.querySelectorAll('.product');
    var shown = 0;

    cards.forEach(function (card) {
      var title = normalize(card.dataset.title);
      var matchesQuery = !query || title.indexOf(query) !== -1;
      var matchesPower = p === 'all' || card.dataset.power === p;
      var matchesThermostat = t === 'all' || card.dataset.thermostat === t;
      var matchesNoise = n === 'all' || card.dataset.noise === n;

      var visible = matchesQuery && matchesPower && matchesThermostat && matchesNoise;
      card.style.display = visible ? '' : 'none';
      if (visible) shown++;
    });

    if (count) {
      count.textContent = 'Showing ' + shown + ' product' + (shown === 1 ? '' : 's');
    }
  }

  function toast(message) {
    var t = document.createElement('div');
    t.textContent = message;
    t.style.position = 'fixed';
    t.style.left = '50%';
    t.style.bottom = '18px';
    t.style.transform = 'translateX(-50%)';
    t.style.background = 'rgba(6,16,29,.88)';
    t.style.border = '1px solid rgba(255,255,255,.16)';
    t.style.color = 'white';
    t.style.padding = '10px 12px';
    t.style.borderRadius = '14px';
    t.style.boxShadow = '0 16px 40px rgba(0,0,0,.35)';
    t.style.zIndex = '999';
    t.style.fontSize = '13px';
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.opacity = '0';
      t.style.transition = 'opacity .25s ease';
    }, 1200);
    setTimeout(function () {
      t.remove();
    }, 1600);
  }

  function toggleCompare() {
    compareMode = !compareMode;
    if (compareBtn) {
      compareBtn.textContent = compareMode ? 'Comparing…' : 'Compare';
    }
    toast(compareMode ? 'Compare mode ON: click products to select.' : 'Compare mode OFF.');
    if (!compareMode) {
      selected.clear();
      root.querySelectorAll('.product').forEach(function (p) {
        p.style.outline = 'none';
      });
    }
  }

  if (q) q.addEventListener('input', applyFilters);
  if (power) power.addEventListener('change', applyFilters);
  if (thermostat) thermostat.addEventListener('change', applyFilters);
  if (noise) noise.addEventListener('change', applyFilters);
  applyFilters();

  root.addEventListener('click', function (e) {
    var card = e.target.closest('.product');
    if (!card) return;

    if (!compareMode) return;

    var id = card.querySelector('.ptitle') ? card.querySelector('.ptitle').textContent : card.dataset.title;
    if (selected.has(id)) {
      selected.delete(id);
      card.style.outline = 'none';
      return;
    }

    if (selected.size >= 3) {
      toast('Select up to 3 items to compare.');
      return;
    }

    selected.add(id);
    card.style.outline = '3px solid rgba(126,227,255,.55)';
    if (selected.size >= 2) {
      toast('Tip: Compare by power, thermostat, and noise preference.');
    }
  });

  if (compareBtn) compareBtn.addEventListener('click', toggleCompare);

  root.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (!id || id === '#') return;
    var el = root.querySelector(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
